module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.7d752fb7.ttf";